
import { Chip } from '@mui/material';
import { tokens } from '../../theme';

const { status } = tokens.color;

const TONES = {
  success: {
    bg: status.activeBg,
    fg: status.activeText,
  },
  warning: {
    bg: status.warnBg,
    fg: status.warnText,
  },
  error: {
    bg: status.alertBg,
    fg: status.alertText,
  },
  neutral: {
    bg: status.draftBg,
    fg: status.draftText,
  },
};

const STATUS_MAP = {
  // Boolean statuses
  true: { tone: 'success', text: 'Active' },
  false: { tone: 'error', text: 'Inactive' },

  // Numeric statuses
  0: { tone: 'error', text: 'Inactive' },
  1: { tone: 'success', text: 'Active' },
  2: { tone: 'neutral', text: 'Retired' },
  3: { tone: 'warning', text: 'Pending' },

  // Existing LMS statuses
  published: { tone: 'success', text: 'Published' },
  active: { tone: 'success', text: 'Active' },
  invited: { tone: 'warning', text: 'Invited' },
  pending: { tone: 'warning', text: 'Pending' },
  draft: { tone: 'neutral', text: 'Draft' },
  inactive: { tone: 'error', text: 'Inactive' },
  retired: { tone: 'neutral', text: 'Retired' },
  error: { tone: 'error', text: 'Error' },
  yes: { tone: 'success', text: 'Yes' },
  no: { tone: 'error', text: 'No' },
  processing: { tone: 'neutral', text: 'Processing' },
  failed: { tone: 'error', text: 'Failed' },
  completed: { tone: 'success', text: 'Completed' },

  // Batch ingestion statuses
  uploading: { tone: 'warning', text: 'Uploading' },
  reading: { tone: 'warning', text: 'Reading' },
  summarizing: { tone: 'warning', text: 'Summarizing' },
  indexing: { tone: 'warning', text: 'Indexing' },
  suggesting: { tone: 'warning', text: 'Suggesting skills' },
  'suggesting skills': {
    tone: 'warning',
    text: 'Suggesting skills',
  },
  retrying: { tone: 'warning', text: 'Retrying' },
  duplicate: { tone: 'warning', text: 'Duplicate' },
  'daily limit reached': {
    tone: 'warning',
    text: 'Daily limit reached',
  },
  skipped: { tone: 'neutral', text: 'Skipped' },
  ready: { tone: 'success', text: 'Ready' },
  queued: { tone: 'neutral', text: 'Queued' },
};

const normalize = (value) =>
  value == null ? '' : String(value).trim().toLowerCase();

export default function StatusPill({
  status: value,
  label,
  onClick,
  sx,
}) {
  const key = normalize(value);

  const config = STATUS_MAP[key] ?? {
    tone: 'neutral',
    text: key || '—',
  };

  const tone = TONES[config.tone];

  return (
    <Chip
      size="small"
      label={label ?? config.text}
      onClick={onClick}
      sx={{
        bgcolor: tone.bg,
        color: tone.fg,

        '& .MuiChip-label': {
          fontWeight: 500,
        },

        '&.MuiChip-clickable:hover, &.MuiChip-clickable:focus': {
          bgcolor: tone.bg,
          filter: 'brightness(0.96)',
        },

        ...sx,
      }}
    />
  );
}
